import { SelectSearchField } from 'components'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'


const propTypes = {
  name        : PropTypes.string,
  label       : PropTypes.string,
  required    : PropTypes.bool,
  apiRequest  : PropTypes.func,
  placeholder : PropTypes.string,
  responseKey : PropTypes.string,
  optionLabel : PropTypes.func
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
 * Search field to select account by account code.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 * @param {func} apiRequest - will handle api request
 * @param {string} placeholder - field placeholder
 * @param {string} responseKey - attribute key that wrap accounts data
 * @param {func} optionLabel - rendered label
 */
const AccountLinkAccountSelectSearchField = ({
  name,
  label,
  required,
  apiRequest,
  placeholder,
  responseKey,
  optionLabel,
  ...props
}) => {

  const { setFieldError, setFieldTouched } = useFormikContext()

  const [ searchAccounts, setSearchAccounts ] = useState([])
  const [ isSearchLoading, setSearchLoading ] = useState(false)
  let accountSearchTimeout                    = null

  // search account by email
  const getAccounts = (values) => {
    setSearchLoading(true)
    const additionalFilters = {}

    additionalFilters['email'] = values

    apiRequest({ additionalFilters: additionalFilters })
      .then((response) => {
        setSearchAccounts(response.data[responseKey])
      })
      .catch(() => {
        setFieldError(name, `Searching for ${name} data failed.`)
        setFieldTouched(name, true, false)
      })
      .finally(() => setSearchLoading(false))
  }

  // handler to search accounts
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    if (accountSearchTimeout) clearTimeout(accountSearchTimeout)
    accountSearchTimeout = setTimeout(() => {
      getAccounts(searchText)
    }, 700)
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder={ placeholder }
      dataList={ searchAccounts }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ optionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={ () => {} }
      { ...props }
    />
  )
}

AccountLinkAccountSelectSearchField.propTypes    = propTypes
AccountLinkAccountSelectSearchField.defaultProps = defaultProps

export default AccountLinkAccountSelectSearchField
